export const environment = {
  production: true,
  API_URL: 'https://helios-prod.zippmat.app',

  SHARE_URL: 'https://rfq.getprice.in',
};
